
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mahashivratri/faq",
      function () {
        return require("private-next-pages/mahashivratri/faq/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mahashivratri/faq"])
      });
    }
  